// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Org Edit Drawer ─────────────────────────────────────────────────────── */

/* ── Header ── */
.org-drawer__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 24px 16px;
  background: #1a1a1a;
  flex-shrink: 0;
}

.org-drawer__header-eyebrow {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #6b7280;
  margin: 0 0 4px;
}

.org-drawer__header-title {
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 6px;
}

.org-drawer__header-id {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 11px;
  color: #9ca3af;
  background: #2d2d2d;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #404040;
}

/* ── Scrollable body ── */
.org-drawer__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
  display: flex;
  flex-direction: column;
}

/* ── Section ── */
.org-drawer__section {
  padding: 20px 24px;
}

.org-drawer__section-title {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #86BC25;
  margin: 0 0 14px;
}

/* ── Field group ── */
.org-drawer__fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Toggle rows ── */
.org-drawer__toggles {
  display: flex;
  flex-direction: column;
}

.org-drawer__toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

.org-drawer__toggle-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  padding-right: 16px;
}

.org-drawer__toggle-label {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.org-drawer__toggle-desc {
  font-size: 11px;
  color: #9ca3af;
}

/* ── Footer ── */
.org-drawer__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
  flex-shrink: 0;
}

.org-drawer__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  transition: background 0.15s;
  font-family: inherit;
}

.org-drawer__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.org-drawer__btn--cancel {
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
}

.org-drawer__btn--cancel:hover:not(:disabled) {
  background: #f3f4f6;
}

.org-drawer__btn--save {
  background: #86BC25;
  color: #fff;
}

.org-drawer__btn--save:hover:not(:disabled) {
  background: #6fa019;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/OrgEditDrawer.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ── Org Edit Drawer ─────────────────────────────────────────────────────── */\n\n/* ── Header ── */\n.org-drawer__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 20px 24px 16px;\n  background: #1a1a1a;\n  flex-shrink: 0;\n}\n\n.org-drawer__header-eyebrow {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #6b7280;\n  margin: 0 0 4px;\n}\n\n.org-drawer__header-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #fff;\n  margin: 0 0 6px;\n}\n\n.org-drawer__header-id {\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 11px;\n  color: #9ca3af;\n  background: #2d2d2d;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid #404040;\n}\n\n/* ── Scrollable body ── */\n.org-drawer__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Section ── */\n.org-drawer__section {\n  padding: 20px 24px;\n}\n\n.org-drawer__section-title {\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #86BC25;\n  margin: 0 0 14px;\n}\n\n/* ── Field group ── */\n.org-drawer__fields {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* ── Toggle rows ── */\n.org-drawer__toggles {\n  display: flex;\n  flex-direction: column;\n}\n\n.org-drawer__toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n}\n\n.org-drawer__toggle-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  padding-right: 16px;\n}\n\n.org-drawer__toggle-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.org-drawer__toggle-desc {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* ── Footer ── */\n.org-drawer__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 24px;\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n  flex-shrink: 0;\n}\n\n.org-drawer__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s;\n  font-family: inherit;\n}\n\n.org-drawer__btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.org-drawer__btn--cancel {\n  background: #fff;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.org-drawer__btn--cancel:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.org-drawer__btn--save {\n  background: #86BC25;\n  color: #fff;\n}\n\n.org-drawer__btn--save:hover:not(:disabled) {\n  background: #6fa019;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
